export default __webpack_public_path__ + "static/media/hand-with-coin.d33c253d.svg";